import { checkDirtyForm, setDirtyForm } from 'app/actions/dirty-forms.actions';
import confirmTemplate from './views/unsaved-changes-cancel-dialog.html';

@Inject('$ngRedux', 'Notifications')
class DirtyFormService {
  check(formName, onClickHandler) {
    const dirty = this.$ngRedux.dispatch(checkDirtyForm(formName));
    if (dirty) {
      this.Notifications.showSimpleDialog(confirmTemplate).result.then(() => {
        this.$ngRedux.dispatch(setDirtyForm(formName, false));
        // call action
        onClickHandler(dirty);
      });
    } else {
      onClickHandler(false);
    }
  }
}

export default DirtyFormService;



// WEBPACK FOOTER //
// ./src/modules/utils/dirty-form/cancel-service.js